import type { TypedTypePolicies } from './__generated__/typed-policies';

export const typedPolicies: TypedTypePolicies = {};
